/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  GamoraFoundationNodeArgs,
  assert,
  debugCreate,
} from '@ver.id/libs.internal.gamora';
import { HoruzProtocolChulakCloseCode } from '../../codes.js';
import { HoruzProtocolChulakServerStateBase } from './base.js';
import { HoruzProtocolChulakServerStateContext } from '../context.js';
import { HoruzProtocolChulakServerStateEvent } from './enums.js';
import { HoruzProtocolChulakServerStateMap } from '../../statemap.js';
import { IHoruz } from '../../../../horuz.js';
const debug = debugCreate({
  namespace: 'horuz:protocols:chulak:states:server:close',
});

/**
 * Server
 * @public
 */
export class HoruzProtocolChulakServerStateClose extends HoruzProtocolChulakServerStateBase<
  typeof HoruzProtocolChulakServerStateMap,
  HoruzProtocolChulakServerStateContext,
  IHoruz
> {
  constructor(args: GamoraFoundationNodeArgs) {
    super(args);
  }

  /**
   * Enter state
   */
  override async $enter(
    serverStateContext: HoruzProtocolChulakServerStateContext,
  ): Promise<void> {
    debug.log(
      '(_onEventEnter): Closed chulak websocket connection for ' +
        serverStateContext.contextIdentifier +
        '.',
    );

    // Stop websocket connection from server side
    if (serverStateContext.ws.readyState === serverStateContext.ws.OPEN) {
      if (serverStateContext.stateContextRegistry.lastError) {
        serverStateContext.ws.close(
          serverStateContext.stateContextRegistry.lastError.code,
          serverStateContext.stateContextRegistry.lastError.reason,
        );
      } else {
        serverStateContext.ws.close(HoruzProtocolChulakCloseCode.OKAY);
      }
    }
  }

  /**
   * Exit state
   */
  override async $exit(
    serverStateContext: HoruzProtocolChulakServerStateContext,
  ): Promise<void> {
    this.$emit(
      serverStateContext.contextIdentifier,
      HoruzProtocolChulakServerStateEvent.Closed,
    );
  }
}
